// R8-3 — THE ATTACHMENTS IN A SENT MESSAGE, LIFTED OUT OF App.tsx VERBATIM.
//
// Props in, tree out, no state, no hook — the entry requirement, so `scripts/r8-leaves.mjs` CALLS it
// and reads the tree back. What that buys, which no regex over App.tsx could: every attachment is
// proved to point at the AUTH-GATED file route (R8-1's `attachmentUrl`) rather than at a raw path,
// each link is proved to carry ITS OWN id rather than the first one in the list, and the image and
// document branches are proved to still be two branches. A wrong href here is a broken picture in a
// reopened conversation with no error anywhere — an <img> 404 is silent.
//
// The `LalaAttachment` type comes with it, the way R7 moved `Generator` and `HomeMenuItem` with
// their catalog: the shape belongs to the thing that renders it, and App.tsx imports it back.
//
// Moved VERBATIM.
import { FileText } from "lucide-react";
import { attachmentUrl } from "../lib/attachments";

export type LalaAttachment = { id: string; kind: string; mediaType: string; filename: string; sizeBytes: number; messageId?: string };

// Attachments rendered inside a sent message bubble, so the thread shows what was sent
// (and still shows it when the conversation is reopened).
export function MessageAttachments({ items }: { items: LalaAttachment[] }) {
  if (!items.length) return null;
  return (
    <div className="msg-attachments">
      {items.map((a) => (
        a.kind === "image"
          ? <a key={a.id} href={attachmentUrl(a.id)} target="_blank" rel="noreferrer" className="msg-attachment msg-attachment--image">
              <img src={attachmentUrl(a.id)} alt={a.filename} loading="lazy" />
            </a>
          : <a key={a.id} href={attachmentUrl(a.id)} target="_blank" rel="noreferrer" className="msg-attachment msg-attachment--doc">
              <FileText size={14} /> {a.filename}
            </a>
      ))}
    </div>
  );
}
